import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogDetailPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPost();
  }, [slug]);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API}/blog/${slug}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error fetching post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div data-testid="blog-detail-loading" className="tattoo-bg-functional min-h-screen">
        <Header />
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-24 min-h-screen flex items-center justify-center">
          <p className="font-body text-lg">Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div data-testid="blog-not-found" className="tattoo-bg-functional min-h-screen">
        <Header />
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-24 min-h-screen flex items-center justify-center">
          <p className="font-heading text-3xl">Post not found</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div data-testid="blog-detail-page" className="tattoo-bg-functional min-h-screen">
      <Header />

      <article className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <Link 
          to="/blog"
          data-testid="back-to-blog-link"
          className="inline-flex items-center gap-2 font-mono text-sm uppercase tracking-widest hover:underline mb-8"
        >
          ← BACK TO JOURNAL
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono text-sm uppercase tracking-widest text-gray-600 mb-4">
            {post.category}
          </p>
          <h1 className="font-heading text-6xl md:text-7xl font-bold mb-6 leading-tight">
            {post.title}
          </h1>
          <p className="font-mono text-sm uppercase tracking-widest text-gray-600 mb-12">
            By {post.author} • {new Date(post.published_at).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </p>

          {post.cover_image && (
            <div className="polaroid mb-12">
              <img
                src={post.cover_image}
                alt={post.title}
                className="w-full h-[500px] object-cover"
              />
            </div>
          )}

          <div className="paper-texture p-8 md:p-12">
            <div className="font-body text-lg leading-relaxed space-y-6">
              {post.content.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </motion.div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetailPage;